/* eslint-disable import/no-named-as-default-member */
/* eslint-disable @typescript-eslint/no-explicit-any */

import { useFetchQuery } from './useFetchQuery'
import { User as UserApi } from '../API'
import { listFormRefunds } from '../api/queries'
import { fetchQuery } from '../utils/ApiUtils'

type User = Omit<Exclude<UserApi, null>, '__typename'>

interface Props {
  email: string
  eventId?: string
}
const useFormRefundByUser = ({ email, eventId }: Props) => {
  const {
    data: user,
    apiLoading,
    apiError,
  } = useFetchQuery(
    async () => {
      const { items } = (await fetchQuery('listFormRefunds', listFormRefunds, {
        filter: { email: { eq: email } },
        sortDirection: 'DESC',
      })) as unknown as { items: User[] }
      return items.length > 0 ? items[0] : null
    },
    [email, eventId],
    'Fail to retrieve data',
    { initialValue: null, guard: !!email },
  )

  return { user, apiLoading, apiError }
}

export default useFormRefundByUser
